import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
// Api
import { MARK_AFFILIATE_COMMISSIONS_PAID } from 'api/streamAffiliate/mutations';
// Types
import {
  MarkAffiliateCommissionsPaid,
  MarkAffiliateCommissionsPaidVariables,
} from 'api/streamAffiliate/types/MarkAffiliateCommissionsPaid';
import { MarkAffiliateCommissionsPaidInput } from 'api/graphql-global-types';

export type MarkCommissionsPaid = {
  /** Resolves to how many orders were marked paid. */
  markPaid: (input: MarkAffiliateCommissionsPaidInput) => Promise<number>;
  busy: boolean;
};

export const useMarkCommissionsPaid = (): MarkCommissionsPaid => {
  const [markPaidMutation, { loading }] = useMutation<
    MarkAffiliateCommissionsPaid,
    MarkAffiliateCommissionsPaidVariables
  >(MARK_AFFILIATE_COMMISSIONS_PAID);

  const markPaid = useCallback(
    async (input: MarkAffiliateCommissionsPaidInput): Promise<number> => {
      const { data } = await markPaidMutation({ variables: { input } });

      return data?.markAffiliateCommissionsPaid ?? 0;
    },
    [markPaidMutation]
  );

  return { markPaid, busy: loading };
};
